import { useEffect } from 'react';
import { useToast } from '../../components/ui/Toast/ToastProvider';
import { registerNotifier } from './notifications';

export function NotifierBridge() {
    const notify = useToast();

    useEffect(() => {
        registerNotifier(notify);
    }, [notify]);

    return null;
}